<template>
  <el-table-column
    prop="name"
    label="Név"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
